var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitnesBracelet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#039BE5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 71.7c9.3 9 20.2 14.5 24.5 11.5 6.8-4.7 1.1-25-13.5-46.5-1.8-2.6-5.1-6-7-8.5m-29.5 7c-5-12-6.3-26-2-29 5-3.4 15.3 2.8 26.5 15L60 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 78.9c-2.6-8.5-7.8-19-15-29.7-2-2.9-4.5-6.7-6.5-9.3M30.5 23.2c3.8 3 8.3 7.2 12.5 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2 83.2 66.1 95.6c-3.6 2.5-12.2-3.8-21.6-12.4M31.7 6.4 13.6 18.8c-3.6 2.5-.7 16.5 3.9 28.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 45.8,
    r: 4.5,
    transform: "rotate(56 63.5 45.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6,
    cy: 58,
    r: 2.5,
    transform: "rotate(56 70.6 58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9,
    cy: 69.6,
    r: 2.5,
    transform: "rotate(56 75 69.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4 52.3c4.1-2.8 4.3-6.3 2.2-10-3-5.5-2.6-9.1-4.3-11.6l-1.8-2.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8 52c-4.1 2.8-7.5 1.7-10.2-1.5-4-5-7.2-6-8.9-8.4l-.7-.9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: 35.8,
    width: 24.2,
    height: 6.3,
    rx: 0.5,
    transform: "rotate(-35 41.7 35.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 48.1,
    width: 24.3,
    height: 45,
    rx: 2.5,
    transform: "rotate(-35 15.7 48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnesBracelet);
export default ForwardRef;